import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRoute, useRouter } from 'vue-router';
  import { NavbarType } from '@/types/navbar';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();

  const navbar: NavbarType[] = [
    { name: t('Wish list'), key: 'mine.shop.wishList' },
    { name: t('My orders'), key: 'mine.shop.myOrders' },
  ];

  const route = useRoute();
  const router = useRouter();

  const activeKey = computed<string>(() => route.name as string);

  // TODO: Event lint不过，先any
  function handleChange(item: any) {
    router.replace({ name: item.key });
  }

return (_ctx: any,_cache: any) => {
  const _component_AppNavbar = _resolveComponent("AppNavbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppNavbar, {
      navbar: navbar,
      "is-router-link": false,
      "active-item-key": _unref(activeKey),
      style: {"margin-bottom":"2.25rem"},
      onChange: handleChange
    }, null, 8, ["active-item-key"]),
    _createVNode(_component_router_view)
  ], 64))
}
}

})